var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTres(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 193.293,
    height: 187.132,
    viewBox: "0 0 51.142 49.512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      clipRule: "evenodd",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#517968",
    d: "M9.87 5.488a1.44 1.44 0 0 0-1.436 1.438V12.7c0 .792.645 1.424 1.437 1.424h11.924l-4.506 5.904c-.606.795-.582 3.02-.582 3.185v6.085c0 .91.734 1.645 1.644 1.645h12.287c1.792 0 1.792 5.981 0 5.981H20.24c-.886 0-2.038.58-2.563 1.295l-2.862 5.153c-.168.303.381 1.916 1.463 1.916h11.718c6.142 0 11.108-5.085 11.108-11.354 0-6.27-4.966-11.355-11.108-11.355h-.66l5.398-7.07c.362-.475 1.243-2.299 1.243-2.809V6.926a1.44 1.44 0 0 0-1.437-1.438z",
    opacity: 0.973
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#150b14",
    d: "M25.835 7.275a2.4 2.4 0 0 0-1.321.013 4.2 4.2 0 0 0-1.023.453c-.49.293-.95.645-1.398.997-.51.401-.975.854-1.45 1.295a.376.376 0 0 0 .504.557c.598-.548 1.195-1.106 1.8-1.645.388-.345.767-.693 1.218-.958a3 3 0 0 1 .66-.285c1.59-.469 2.796 1.226 3.935 2.033.483.342.98.567 1.554.7a4.2 4.2 0 0 1-1.488-.79c-.975-.797-1.811-2.033-2.991-2.37",
    opacity: 0.973
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#150b14",
    d: "M28.062 9.295a3.78 3.78 0 0 1-3.406.777c-.539-.14-1-.455-1.527-.622-.464-.146-.934-.116-1.399 0a.373.373 0 1 0 .181.725c.924-.223 1.763.244 2.668.35 1.285.15 2.605-.269 3.483-1.23",
    opacity: 0.973
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87 5.58a1.44 1.44 0 0 0-1.436 1.437v2.667c.248.052.486.142.75.142h.13a3.74 3.74 0 0 0 3.742-3.728c0-.184-.078-.342-.104-.518z",
    opacity: 0.973
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#c9b09a",
    d: "m34.294 5.7-.036 2.42c-.013.884-.614 1.375-1.342 1.097l-1.994-.762-1.995-.762c-.728-.278-.717-.995.024-1.6l2.031-1.659 2.03-1.658c.742-.605 1.332-.38 1.319.504z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#436557",
    d: "M33.936 2.356c.22.072.347.3.395.624a1.5 1.5 0 0 0-.643.315l-2.143 1.708-2.142 1.702c-.448.357-.606.737-.535 1.052l-.202-.066c-.798-.261-.807-.975-.024-1.598l2.143-1.707 2.141-1.703c.391-.311.749-.412 1.01-.327"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d521b",
    d: "M23.768 8.574a1.175 1.175 0 1 1 2.349 0 1.175 1.175 0 0 1-2.349 0",
    opacity: 0.973
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.426 8.656c0-.649.115-1.175.258-1.175s.259.526.259 1.175-.116 1.174-.259 1.174-.258-.525-.258-1.174",
    opacity: 0.973
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#150b14",
    d: "M12.758 9.994a.4.4 0 0 0-.233.181.37.37 0 0 0 .142.505c.515.295 1.038.61 1.58.855 2.622 1.185 5.46 1.725 8.312 1.942-1.966-.302-3.891-.744-5.736-1.502-1.311-.54-2.547-1.246-3.78-1.942a.38.38 0 0 0-.285-.039m-.984.984a.38.38 0 0 0-.246.155.37.37 0 0 0 .09.518c4.07 2.885 8.808 4.595 13.517 6.124-2.49-.957-4.955-1.96-7.328-3.185-2.004-1.034-3.917-2.251-5.761-3.547a.36.36 0 0 0-.272-.065m-.997.945a.36.36 0 0 0-.272.078.38.38 0 0 0-.052.53c.43.527.89.996 1.45 1.386.9.627 1.911 1.094 2.836 1.683 1.937 1.235 3.785 2.565 5.994 3.276-2.34-.926-4.217-2.547-6.227-4.014-1.21-.883-2.507-1.637-3.47-2.81a.38.38 0 0 0-.26-.129",
    opacity: 0.973
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTres);
export default __webpack_public_path__ + "static/media/tres.7e9865287fbb353053bd736d85e63cb1.svg";
export { ForwardRef as ReactComponent };